import PropTypes from 'prop-types';
import React from 'react';
import icons from './SortableTableHeaderCell.icons.jsx';
import styles from './SortableTableHeaderCell.scss';
import {
  getPassthroughProps
} from '../componentHelpers.js';

class SortableTableHeaderCell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
    };
  }

  render() {
    return (
      <th
        className={this.props.className}
        onClick={() => this.toggleSort()}
        onMouseEnter={() => this.setState({hover: true})}
        onMouseLeave={() => this.setState({hover: false})}
        {...getPassthroughProps(this)}
      >
        <span className={styles.sortIconContainer}>
          {this.props.children}
          {this.renderIcon()}
        </span>
      </th>
    );
  }

  renderIcon() {
    let { hover } = this.state;

    if (hover) {
      return icons.hover;
    }

    let { direction } = this.props;

    switch(direction) {
    case 'asc':
      return icons.ascending;

    case 'desc':
      return icons.descending;

    case null:
    case undefined:
      return null;
    }
  }

  toggleSort() {
    let newDirection;

    if (this.props.direction === 'asc') {
      newDirection = 'desc';
    } else {
      newDirection = 'asc';
    }

    this.props.onSort(newDirection);
  }
}

SortableTableHeaderCell.propTypes = {
  onSort: PropTypes.func,
  direction: PropTypes.oneOf(['asc', 'desc']),
  sortKey: PropTypes.string,
};

SortableTableHeaderCell.defaultProps = {
  onSort: () => {},
};

export default SortableTableHeaderCell;
